import { render, staticRenderFns } from "./Claims.yaml?vue&type=template&id=c281df54&component"
import script from "./Claims.yaml?vue&type=script&lang=ts&component"
export * from "./Claims.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports